import { lazyLoad } from 'utils/loadable';

export const ProductsWithImagesPage = lazyLoad(
    () => import('./index'),
    module => module.ProductsWithImagesPage,
);
